import { LocalDate } from '@js-joda/core';
import { UserPlanBasicsFragment } from '../../../graphql/types';

export const getPlanStatus = (plan?: UserPlanBasicsFragment) => {
  if (!plan) {
    return null;
  }

  if (plan.archivedAt) {
    return 'Archived';
  }

  const now = LocalDate.now();
  const startDate = LocalDate.parse(plan.startDate);
  const endDate = LocalDate.parse(plan.endDate);

  if (now.isBefore(startDate)) {
    return 'Upcoming';
  }

  if (now.isAfter(endDate)) {
    return 'Completed';
  }

  return 'Active';
};

export enum FocusAreas {
  Fitness = 'Fitness',
  MentalEmotionalWellBeing = 'Mental & Emotional Well-Being',
  WeightLoss = 'Weight Loss',
  LongevityHealthyAging = 'Longevity & Healthy Aging',
  MuscleGrowth = 'Muscle Growth',
  Sharpness = 'Sharpness',
  FemaleWellBeing = 'Female Well-Being',
  BasicHealth = 'Basic Health',
}
